const APIURL = import.meta.env.VITE_APIURL
const API_ASSETS_URL = import.meta.env.VITE_APIASSETSURL

const Constants = {
	/** FEATURES FLAG **/
	FEATURE_CONTENEUR_CONSIGNES: true,

	/** API ROUTE */
	API_ROUTE_LOGIN: APIURL + "/login_check",
	API_ROUTE_TOKEN_REFRESH: APIURL + "/refresh",
	API_ROUTE_ASK_RESET_PASSWORD: APIURL + "/users/ask-reset-password ",
	API_ROUTE_RESET_PASSWORD: APIURL + "/users/reset-password",
	API_ROUTE_USERS: APIURL + "/users",
	API_ROUTE_USER: APIURL + "/users/:id",
	API_ROUTE_EXPLOITANTS: APIURL + "/exploitants",
	API_ROUTE_EXPLOITANT: APIURL + "/exploitants/:id",
	API_ROUTE_ADMINS: APIURL + "/admins",
	API_ROUTE_ADMIN: APIURL + "/admins/:id",
	API_ROUTE_CLIENTS: APIURL + "/clients",
	API_ROUTE_CLIENT: APIURL + "/clients/:id",
	API_ROUTE_OPERATEURS: APIURL + "/operateurs",
	API_ROUTE_OPERATEUR: APIURL + "/operateurs/:id",
	API_ROUTE_USERS_LOGO: APIURL + "/user_logos",
	API_ROUTE_PATRIMOINES: APIURL + "/patrimoines",
	API_ROUTE_PATRIMOINES_LIGHT: APIURL + "/patrimoines/light?client=:id",
	API_ROUTE_PATRIMOINE: APIURL + "/patrimoines/:id",
	API_ROUTE_PATRIMOINES_CLIENT: APIURL + "/patrimoines?client=:id",
	API_ROUTE_PATRIMOINE_INTERVENTIONS: APIURL + "/patrimoines/:id?groups=patrimoineintervention",
	API_ROUTE_PROBLEMS: APIURL + '/problems',
	API_ROUTE_PROBLEM: APIURL + '/problems/:id',
	API_ROUTE_PROBLEMS_LAVEUSE: APIURL + '/problem_laveuses',
	API_ROUTE_PROBLEM_LAVEUSE: APIURL + '/problem_laveuses/:id',
	API_ROUTE_PRESTATIONS: APIURL + '/prestations',
	API_ROUTE_PRESTATION: APIURL + '/prestations/:id',
	API_ROUTE_AGENCES: APIURL + '/agences',
	API_ROUTE_AGENCE: APIURL + '/agences/:id',
	API_ROUTE_TYPOLOGIES_LAVAGE: APIURL + '/typologie_lavages',
	API_ROUTE_TYPOLOGIE_LAVAGE: APIURL + '/typologie_lavages/:id',
	// Référentiel consignes / actes / modes opératoires
	API_ROUTE_CONSIGNES: APIURL + '/consignes',
	API_ROUTE_CONSIGNE: APIURL + '/consignes/:id',
	API_ROUTE_ACTES: APIURL + '/actes',
	API_ROUTE_ACTE: APIURL + '/actes/:id',
	API_ROUTE_ELEMENT_MAINTENANCES: APIURL + '/element_maintenances',
	API_ROUTE_ELEMENT_MAINTENANCE: APIURL + '/element_maintenances/:id',
	API_ROUTE_MODE_OPERATOIRES: APIURL + '/mode_operatoires',
	API_ROUTE_MODE_OPERATOIRE: APIURL + '/mode_operatoires/:id',
	API_ROUTE_MODE_OPERATOIRE_FICHIERS: APIURL + '/mode_operatoire_fichiers',
	API_ROUTE_MODE_OPERATOIRE_FICHIER: APIURL + '/mode_operatoire_fichiers/:id',
	API_ROUTE_CONTENEUR_CONSIGNES: APIURL + '/conteneur_consignes',
	API_ROUTE_CONTENEUR_CONSIGNE: APIURL + '/conteneur_consignes/:id',
	API_ROUTE_FORM_ACTES: APIURL + '/form_actes',
	API_ROUTE_FORM_ACTE: APIURL + '/form_actes/:id',
	API_ROUTE_DOCUMENT_UPLOAD: APIURL + '/documents/upload',
	API_ROUTE_FORMS: APIURL + '/forms',
	API_ROUTE_FORM: APIURL + '/forms/:id',
	API_ROUTE_LAVEUSES: APIURL + '/laveuses',
	API_ROUTE_LAVEUSE: APIURL + '/laveuses/:id',
	API_ROUTE_LAVEUSE_TELEMATICS: APIURL + '/laveuses/:id/telematics',
	API_ROUTE_LAVEUSES_TELEMATICS_BULK: APIURL + '/laveuses/telematics',
	API_ROUTE_LAVEUSE_DAILY_CONTEXT: APIURL + '/laveuses/:id/daily-context?date=:date',
	API_ROUTE_LAVEUSE_QR_CODE: APIURL + '/qr/:id',
	API_ROUTE_CONTENEURS: APIURL + '/conteneurs',
	API_ROUTE_CONTENEUR: APIURL + '/conteneurs/:id',
	// Carte conteneurs (vue Patrimoine v2) — renvoie une FeatureCollection GeoJSON
	API_ROUTE_CLIENT_CONTENEURS_GEOJSON: APIURL + '/clients/:clientId/conteneurs/geojson',
	API_ROUTE_INTERVENTIONS: APIURL + '/interventions',
	API_ROUTE_INTERVENTIONS_BY_CONTAINERID: APIURL + '/interventions?containerId=:id',
	API_ROUTE_INTERVENTIONS_BY_PATRIMOINEID: APIURL + '/patrimoine/:id/interventions',
	API_ROUTE_INTERVENTION: APIURL + '/interventions/:id',
	API_ROUTE_CAMPAIGNS: APIURL + '/campagne_lavages',
	API_ROUTE_CAMPAIGN: APIURL + '/campagne_lavages/:id',
	// Graffiti campaigns (TourneeGraffiti)
	API_ROUTE_TOURNEES_GRAFFITI: APIURL + '/tournee_graffitis',
	API_ROUTE_TOURNEE_GRAFFITI: APIURL + '/tournee_graffitis/:id',
	// Comparaison ordre prévu / réalisé d'une tournée (read model TourneeComparaison)
	API_ROUTE_CAMPAIGN_DETAILS_CONTENEURS_INTERVENTIONS: APIURL + '/tournees/:id/comparaison?date=:date',
	API_ROUTE_SYNTHESE: APIURL + '/synthese',
	// REP-03 : bilan par actes (read model BilanActes + classeur xlsx)
	API_ROUTE_BILAN_ACTES: APIURL + '/bilans/actes/:clientId',
	API_ROUTE_BILAN_ACTES_XLSX: APIURL + '/bilans/actes/:clientId/xlsx',
	API_ROUTE_SYNTHESE_INTERVENTION: APIURL + '/synthese/intervention/:id',
	API_ROUTE_SYNTHESE_INTERVENTION_TOKEN: "95735835-5def-47f5-94bf-912e8d4620f2",
	API_ROUTE_REPORTING_TOURNEES: APIURL + '/reporting-tournees',
	API_ROUTE_REPORTING_TOURNEES_EXPORT: APIURL + '/reporting-tournees/export',
	API_ROUTE_REPORTING_TOURNEE: APIURL + '/reporting-tournees/:id',
	API_ROUTE_DASHBOARD_DATA: APIURL + '/dashboard',
	API_ROUTE_DASHBOARD_DATA_V2: APIURL + '/newdashboard',
	API_ROUTE_DASHBOARD_OPERATEUR: APIURL + '/dashboard-operateur',
	API_ROUTE_DASHBOARD_DATA_CLIENT: APIURL + '/dashboard-client',
	API_ROUTE_RHDATAS: APIURL + '/r_h_datas',
	API_ROUTE_RHDATA: APIURL + '/r_h_datas/:id',
	API_ROUTE_FEUILLEDETEMPS: APIURL + '/feuille_de_temps',
	API_ROUTE_FEUILLEDETEMP: APIURL + '/feuille_de_temps/:id',
	API_ROUTE_PERIODE_PAIES: APIURL + '/periode_paies',
	API_ROUTE_PERIODE_PAIE: APIURL + '/periode_paies/:id',
	API_ROUTE_RH_SUIVI_HEURES: APIURL + '/suivi-heures?startDate=:startDate&endDate=:endDate',
	API_ROUTE_EXPORT_SUIVI_HEURES: APIURL + '/suivi-heures/export',
	API_ROUTE_RH_FICHE_CHANTIER: APIURL + '/fiche-chantier?startDate=:startDate&endDate=:endDate&operateurId=:operateurId',
	API_ROUTE_RH_CREATE_FDT: APIURL + "/suivi-heures/create",
	API_ROUTE_RH_CREATE_EMPTY_FDT: APIURL + "/suivi-heures/createEmpty",
	API_ROUTE_RH_EQUIPAGE_DETAIL: APIURL + "/suivi-heures/:id/equipageDetail",
	API_ROUTE_RH_FEUILLES_TEMPS_HEBDO: APIURL + "/feuilles-de-temps-hebdomadaire",
	API_ROUTE_POSTE_OPERATEUR: APIURL + "/poste_operateurs/:id",
	API_ROUTE_ALERTE_RH: APIURL + "/alertes-rh/:id",
	API_ROUTE_RH_HEURES_HEBDO: APIURL + '/rh/heures-hebdomadaire',
	API_ROUTE_RH_VALIDATION_SEMAINE: APIURL + '/rh/validation-semaine',
	API_ROUTE_RH_VALIDATION_SEMAINE_DELETE: APIURL + '/rh/validation-semaine/:id',
	API_ROUTE_RH_DEPLACEMENTS: APIURL + '/rh/deplacements',
	API_ROUTE_RH_DEPLACEMENT_DELETE: APIURL + '/rh/deplacements/:id',
	API_ROUTE_QUARTIX_ENGINE_TIMES: APIURL + '/quartix/vehicle-engine-times?date=:date&vehicleId=:vehicleId',
	API_ROUTE_QUARTIX_TRIP_SUMMARY: APIURL + '/quartix/vehicle-trip-summary?date=:date&vehicleId=:vehicleId',
	API_ROUTE_QUARTIX_ROUTE: APIURL + '/quartix/vehicle-route?date=:date&vehicleId=:vehicleId',
	API_ROUTE_RELEVES_TERRAIN: APIURL + '/releve_terrains',
	API_ROUTE_CONTENEUR_APPLY_RELEVE: APIURL + '/conteneur/:id/apply-releve/:releveId',
	// Graffiti API routes
	API_ROUTE_GRAFFITI_COMMUNES: APIURL + '/graffiti/:clientId/communes',
	API_ROUTE_GRAFFITI_QUARTIERS: APIURL + '/graffiti/:clientId/quartiers',
	API_ROUTE_GRAFFITI_RUES: APIURL + '/graffiti/:clientId/rues',
	API_ROUTE_GRAFFITI_METADATA: APIURL + '/graffiti/:clientId/metadata',
	API_ROUTE_GRAFFITI_COMMUNE_FEATURE: APIURL + '/graffiti/:clientId/communes/:id',
	API_ROUTE_GRAFFITI_QUARTIER_FEATURE: APIURL + '/graffiti/:clientId/quartiers/:id',
	API_ROUTE_GRAFFITI_RUES_SEARCH: APIURL + '/graffiti/:clientId/rues/search',
	API_ROUTE_GRAFFITI_RUE_FEATURE: APIURL + '/graffiti/:clientId/rues/:id',
	API_ROUTE_GRAFFITI_INTERVENTIONS: APIURL + '/graffiti/interventions',
	// Détail d'une intervention graffiti
	API_ROUTE_GRAFFITI_INTERVENTION_DETAIL: APIURL + '/graffiti/:id/interventions',
	API_ROUTE_GRAFFITI_EXPORT: APIURL + '/graffiti/export',
	// Geo API routes
	API_ROUTE_VILLES: APIURL + '/villes',
	// Contrôle qualité (anomalies de saisie terrain)
	API_ROUTE_ANOMALIES: APIURL + '/anomalie_interventions',
	API_ROUTE_ANOMALIE: APIURL + '/anomalie_interventions/:id',
	API_ROUTE_ANOMALIES_COUNT: APIURL + '/anomalie_interventions/count',

	API_ASSETS_USER_LOGO: API_ASSETS_URL,
	API_ASSETS_PDF: API_ASSETS_URL,
	API_ASSETS_PHOTO_INTERVENTION: API_ASSETS_URL,
	API_ASSETS_DOCUMENT: API_ASSETS_URL,


	/** APP ROUTE */
	APP_ROUTE_LOGIN: "/login",
	APP_ROUTE_FORGOT_PASSWORD: "/forgotPassword",
	APP_ROUTE_RESET_PASSWORD: "/resetPassword/:token",
	APP_ROUTE_HOME: "/",
	APP_ROUTE_ADMIN_USERS: "/admin/users",
	APP_ROUTE_ADMIN_USERS_NEW: "/admin/users/new",
	APP_ROUTE_ADMIN_USERS_EDIT: "/admin/users/:type/:id/edit",
	APP_ROUTE_PATRIMOINE: "/patrimoine",
	APP_ROUTE_PATRIMOINE_V2: "/patrimoine-v2",
	APP_ROUTE_GRAFFITI_PATRIMOINE: "/graffiti-patrimoine",
	APP_ROUTE_GRAFFITI_PATRIMOINE_DETAIL: "/graffiti-patrimoine/:id/detail/",
	// Détail d'une intervention graffiti
	APP_ROUTE_GRAFFITI_INTERVENTION_DETAIL: "/graffiti-intervention/:id/detail",
	APP_ROUTE_PATRIMOINE_NEW: "/patrimoine/:id/new/",
	APP_ROUTE_PATRIMOINE_EDIT: "/patrimoine/:patrimoineId/edit",
	APP_ROUTE_PATRIMOINE_IMPORT: "/patrimoine/:id/import/",
	APP_ROUTE_PATRIMOINE_DETAIL: "/patrimoine/:id/detail/",
	APP_ROUTE_CONTENEUR_NEW: "/patrimoine/:patrimoineId/conteneur/new",
	APP_ROUTE_CONTENEUR_EDIT: "/patrimoine/:patrimoineId/conteneur/:conteneurId/edit",
	APP_ROUTE_INTERVENTIONS: "/conteneurs/:id/interventions",
	APP_ROUTE_INTERVENTIONS_UNIPATRIMOINE: "/patrimoine/:id/interventions",
	APP_ROUTE_ADMIN_PROBLEMS: "/admin/problems",
	APP_ROUTE_ADMIN_PROBLEMS_NEW: "/admin/problems/new",
	APP_ROUTE_ADMIN_PROBLEMS_EDIT: "/admin/problems/:id/edit",
	APP_ROUTE_ADMIN_PROBLEMS_LAVEUSES_NEW: "/admin/problemsLaveuses/new",
	APP_ROUTE_ADMIN_PROBLEMS_LAVEUSES_EDIT: "/admin/problemsLaveuses/:id/edit",
	APP_ROUTE_ADMIN_PRESTATIONS: "/admin/prestations",
	APP_ROUTE_ADMIN_PRESTATIONS_NEW: "/admin/prestations/new",
	APP_ROUTE_ADMIN_PRESTATIONS_EDIT: "/admin/prestations/:id/edit",
	APP_ROUTE_ADMIN_AGENCES: "/admin/agences",
	APP_ROUTE_ADMIN_AGENCES_NEW: "/admin/agences/new",
	APP_ROUTE_ADMIN_AGENCES_EDIT: "/admin/agences/:id/edit",
	APP_ROUTE_ADMIN_REFERENTIEL: "/admin/referentiel",
	APP_ROUTE_ADMIN_TYPOLOGIES: "/admin/typologies",
	APP_ROUTE_ADMIN_TYPOLOGIES_NEW: "/admin/typologies/new",
	APP_ROUTE_ADMIN_TYPOLOGIES_EDIT: "/admin/typologies/:id/edit",
	APP_ROUTE_ADMIN_CONSIGNES: "/admin/consignes",
	APP_ROUTE_ADMIN_CONSIGNES_NEW: "/admin/consignes/new",
	APP_ROUTE_ADMIN_CONSIGNES_EDIT: "/admin/consignes/:id/edit",
	APP_ROUTE_ADMIN_MODES_OPERATOIRES: "/admin/modes-operatoires",
	APP_ROUTE_ADMIN_MODES_OPERATOIRES_NEW: "/admin/modes-operatoires/new",
	APP_ROUTE_ADMIN_MODES_OPERATOIRES_EDIT: "/admin/modes-operatoires/:id/edit",
	APP_ROUTE_ADMIN_ACTES: "/admin/actes",
	APP_ROUTE_ADMIN_ACTES_NEW: "/admin/actes/new",
	APP_ROUTE_ADMIN_ACTES_EDIT: "/admin/actes/:id/edit",
	APP_ROUTE_ADMIN_FORMS: "/admin/forms",
	APP_ROUTE_ADMIN_FORMS_NEW: "/admin/forms/new",
	APP_ROUTE_ADMIN_FORMS_EDIT: "/admin/forms/:id/edit",
	APP_ROUTE_ADMIN_LAVEUSES: "/admin/laveuses",
	APP_ROUTE_LAVEUSES_TRACKING_PAGE: "/laveuses-tracking",
	APP_ROUTE_LAVEUSES_TRIPS_PAGE: "/laveuses/:id/trips",
	APP_ROUTE_ADMIN_LAVEUSES_NEW: "/admin/laveuses/new",
	APP_ROUTE_ADMIN_LAVEUSES_EDIT: "/admin/laveuses/:id/edit",
	APP_ROUTE_ADMIN_LAVEUSES_JOURNAL: "/admin/laveuses/:id/journal",
	APP_ROUTE_ADMIN_CAMPAIGNS: "/admin/tournees",
	APP_ROUTE_ADMIN_CAMPAIGNS_NEW: "/admin/tournees/new",
	APP_ROUTE_ADMIN_CAMPAIGNS_EDIT: "/admin/tournees/:id/edit",
	APP_ROUTE_ADMIN_CAMPAIGNS_UPDATE: "/admin/tournees/:id/update",
	// Graffiti specific CRUD routes
	APP_ROUTE_ADMIN_TOURNEES_GRAFFITI_NEW: "/admin/tournees-graffiti/new",
	APP_ROUTE_ADMIN_TOURNEES_GRAFFITI_EDIT: "/admin/tournees-graffiti/:id/edit",
	APP_ROUTE_ADMIN_INTERVENTIONS_FORM: "/admin/intervention/form",
	APP_ROUTE_ADMIN_RH_DATA: "/admin/rhdata",
	APP_ROUTE_ADMIN_RH_DATA_EDIT: "/admin/rhdata/:id/edit",
	APP_ROUTE_RH_SUIVIHEURES: "/RH/suivi-heures",
	APP_ROUTE_RH_FICHECHANTIER: "/RH/fiche-chantier",
	APP_ROUTE_RH_VALIDATION_HEURES: "/RH/validation-heures",
	APP_ROUTE_RH_PERIODE_PAIES: "/RH/periode-paies",
	APP_ROUTE_RH_PERIODE_PAIES_NEW: "/RH/periode-paies/new",
	APP_ROUTE_RH_PERIODE_PAIES_EDIT: "/RH/periode-paies/:id/edit",
	APP_ROUTE_RH_FDT_NEW: "/RH/heures/new",
	APP_ROUTE_SYNTHESE: "/synthese",
	APP_ROUTE_MES_EXPORTS: "/mes-exports",
	APP_ROUTE_REPORTING_TOURNEES: "/reporting-tournees",
	APP_ROUTE_DASHBOARD: "/dashboard",
	APP_ROUTE_PLANNING_GSHEET: "/planning",
	APP_ROUTE_CONTROLE_QUALITE: "/exploitation/controle-qualite",

	/** CONTRÔLE QUALITÉ **/
	ANOMALIE_RESOLUTION_PATRIMOINE_MAJ: "patrimoine_maj",
	ANOMALIE_RESOLUTION_INTERVENTION_CORRIGEE: "intervention_corrigee",
	ANOMALIE_RESOLUTION_IGNOREE: "ignoree",
	ANOMALIE_RESOLUTION_VALIDEE: "validee",
	ANOMALIE_TYPE_ECART_QUANTITE: "ECART_QUANTITE",
	ANOMALIE_TYPE_LAVAGE_IMPOSSIBLE: "LAVAGE_IMPOSSIBLE",
	// Importance max = problème critique, seule raison valable d'un lavage impossible.
	// Les importances inférieures sont des sujets de maintenance.
	PROBLEM_IMPORTANCE_CRITIQUE: 4,
	ANOMALIES_COUNT_POLLING_MS: 15 * 60 * 1000, // 15 minutes

	/** MES EXPORTS **/
	// Polling du watcher : uniquement quand des exports sont en cours de generation
	EXPORTS_POLLING_MS: 5000,

	/** DIVERS */
	MAX_FILESIZE_UPLOAD: 2 * 100000, // 2 MO
	GOOGLEMAPS_API_KEY: 'AIzaSyCGTI7RjTZ50rdshWTSgCAlZo9inXLCb9w',

	/** DATA EN DUR */
	CONTENEURS_TYPE: [
		{code: "CA", libelle: "Colonne Aérienne"},
		{code: "CE", libelle: "Colonne Enterrée"},
		{code: "CSE", libelle: "Colonne Semi-enterrée"},
		{code: "AB", libelle: "Abri-bac"},
		{code: "BAC", libelle: "Bac"},
		{code: "AUT", libelle: "Autre"},
	],


	DECHET_TYPES: [
		{code: "VER", libelle: "Verre"},
		{code: "OM", libelle: "Ordures ménagères"},
		{code: "REC", libelle: "Recyclable"},
		{code: "PAP", libelle: "Papier"},
		{code: "BIO", libelle: "Bio"},
		{code: "AUT", libelle: "Autre"},
	],

	PROBLEMS_IMPORTANCE: [
		{code: 1, libelle: "Bas", color: "#7bb421"},
		{code: 2, libelle: "Moyen", color: "#f1c40f"},
		{code: 3, libelle: "Haut", color: "#e67e22"},
		{code: 4, libelle: "Critique", color: "#B22222"},
	],

	PROBLEMS_LAVEUSE_IMPORTANCE: [
		{code: 3, libelle: "Maintenance", color: "#e67e22"},
		{code: 4, libelle: "Critique", color: "#B22222"},
	],

	LAVEUSE_PROBLEMS_CATEGORIES: [
		{code: "machine", libelle: "Machine"},
		{code: "vehicule", libelle: "Véhicule"},
	],

	LAVEUSE_STATUT: [
		{code: 1, libelle: "Disponible", color: "#7bb421"},
		{code: 3, libelle: "Maintenance nécessaire", color: "#e67e22"},
		{code: 4, libelle: "En panne", color: "#B22222"},
	],

	CONTENEURS_STATUS_TODO: 1,
	CONTENEURS_STATUS_DONE: 0,
	CONTENEURS_STATUS_INACCESSIBLE: 3,
	CONTENEURS_STATUS_PROBLEME: 2,

	CONTENEURS_STATUS_TODO_LIBELLE: "Non lavé",
	CONTENEURS_STATUS_DONE_LIBELLE: "Lavé",
	CONTENEURS_STATUS_INACCESSIBLE_LIBELLE: "Lavage impossible",
	CONTENEURS_STATUS_PROBLEME_LIBELLE: "Maintenance nécessaire",

	DASHBOARD_VIEW_MODE_OLD: "DASHBOARD_VIEW_MODE_OLD",
	DASHBOARD_VIEW_MODE_LIST: "DASHBOARD_VIEW_MODE_LIST",
	DASHBOARD_VIEW_MODE_MAP: "DASHBOARD_VIEW_MODE_MAP",

	/** MAP **/
	MAP_RADIUS: 0.0003,
	DEGREES_PER_RADIAN: 180 / Math.PI,
	HERE_MAPS_APIKEY: "MuhS6u_L01hoP99vEg4KOZPmqfatW-t9GTPZOT_WHnQ",
	MODE_MAP: "map",
	MODE_LIST: "list",
	MAP_TILE_HERE: "https://{s}.{base}.maps.ls.hereapi.com/maptile/2.1/{type}/{mapID}/{variant}/{z}/{x}/{y}/256/{format}?apiKey={apiKey}&lg={language}",
	MAP_TILE_OSM: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",

	/** CSV MISC **/
	EXPECTED_PATRIMOINE_HEADER: ["Nomenclature", "Adresse", "Complement d'adresse", "Commune", "Type de conteneur", "Marque", "Quantite", "Type de dechet", "Volume", "Latitude", "Longitude"],
	EXPECTED_UPDATE_TOURNEE_HEADER: ["Nomenclature", "Adresse"],

	/** SYNTHESE **/
	BILAN_TYPE_GLOBAL: "global",
	BILAN_TYPE_BY_PATRIMOINE: "patrimoine",
	SYNTHESE_FORMAT_XLSX: "XLSX",

	/** TYPOLOGIE LAVAGE **/
	TYPOLOGIE_LAVAGE_AB_PLUS_B: "ABRI BAC + BAC",
	TYPOLOGIE_LAVAGE_AB: "ABRI BAC",
	TYPOLOGIE_LAVAGE_B: "BAC",
	TYPOLOGIE_LAVAGE_C: "COLONNE",

	/** PRESTATIONS CATEGORIES **/
	PRESTATION_CATEGORY_PRESTATIONS: "container",
	PRESTATION_CATEGORY_TYPOLOGIELAVAGE: "laveuse",

	/** PROBLEM CATEGORY */
	PROBLEM_CATEGORY_CONTAINER: "container",
	PROBLEM_CATEGORY_LAVEUSE: "laveuse",

	/** COLORS **/
	COLOR_THEME_BLUE: "#213067",
	COLOR_THEME_GREEN: "#7bb421",
	COLOR_THEME_ORANGE: "#e67e22",
	COLOR_THEME_RED: "#B22222",

	/** HEURES **/
	TEMPS_PAUSE_MINUTES_DATA: [
		{label: "Pas de pause", value: 0},
		{label: "5 minutes", value: 5},
		{label: "15 minutes", value: 15},
		{label: "30 minutes", value: 30},
		{label: "45 minutes", value: 45},
		{label: "1 heure", value: 60},
		{label: "1 heure 15 minutes", value: 75},
		{label: "1 heure 30 minutes", value: 90},
		{label: "1 heure 45 minutes", value: 105},
		{label: "2 heures", value: 120},
		{label: "2 heures 15 minutes", value: 135},
		{label: "2 heures 30 minutes", value: 150},
		{label: "2 heures 45 minutes", value: 165},
		{label: "3 heures", value: 180},
		{label: "3 heures 15 minutes", value: 195},
		{label: "3 heures 30 minutes", value: 210},
		{label: "3 heures 45 minutes", value: 225},
		{label: "4 heures", value: 240},
	],

	RH_STATUT_JOURNEE_DATA: [
		{id: "WD", label: "Travail", color: "#7bb421", fontColor: "#000"},
		{id: "AM", label: "Arrêt Maladie", color: "#213067", fontColor: "#FFF"},
		{id: "CP", label: "Congé Payé", color: "#6f42c1", fontColor: "#FFF"},
		{id: "Repos", label: "Repos", color: "#f1c40f", fontColor: "#000"},
		{id: "JF", label: "Jour Férié", color: "#E91E63", fontColor: "#FFF"},
		{id: "JFT", label: "Jour Férié Travaillé", color: "#FF8559", fontColor: "#000"},
	],

	LAVEUSE_ENGINE_ON_KEYWORDS: [
		"Ignition-On",
		"moteur tournant",
		"Distance",
		"En déplacement",
		"Départ",
		"Mouvement détecté"
	],

	LAVEUSE_ENGINE_OFF_KEYWORDS: [
		"Ignition-Off",
		"arrêt moteur",
		"Stationnaire arrêt moteur",
		"Mouvement inactif",
		"Stop"
	],

	STRATEGIE_LAVAGE_IMPOSSIBLE: [
		{id: 0, label: "Aucune"},
		{id: 1, label: "Lavage Partiel"},
	],
	TYPOLOGIE_CONTENEUR_GROUPS: [
		{label: 'BAC', codes: ['AB', 'BAC']},
		{label: 'COLONNE', codes: ['CA', 'CE', 'CSE']},
	],
}
export default Constants;
